// Экран /confirm-email (B6, ТЗ демо 1.2, 2026-10-20). Модуль без импортов приложения: его проверяет
// tests/email-confirm.test.ts под Node.

export type VerifyErrorCode = 'EXPIRED_TOKEN' | 'RATE_LIMIT' | 'NETWORK' | 'UNKNOWN';

/**
 * Ответ `PUT /auth/verify-user` → вид ошибки. Истёкшую, уже использованную и неверную ссылку сервер не
 * различает: 400 `TOKEN_EXPIRED` (ключ ссылки стирается при подтверждении); 401 и 404 — прежние ответы.
 * null — ответа нет (сеть).
 */
export function classifyVerifyError(response: { status: number; code?: string | null } | null): VerifyErrorCode {
  if (!response) return 'NETWORK';
  const { status, code } = response;
  if ((status === 400 && code === 'TOKEN_EXPIRED') || status === 401 || status === 404) return 'EXPIRED_TOKEN';
  if (status === 429) return 'RATE_LIMIT';
  return 'UNKNOWN';
}

export type ConfirmScreen =
  | 'pending'
  | 'success'
  /** Ссылка устарела, ученик вошёл, почта уже подтверждена — успех, а не ошибка. */
  | 'already'
  /** Ссылка устарела, ученик вошёл, почта не подтверждена — новое письмо отсюда же. */
  | 'expiredApp'
  /** Ссылка устарела, ученик не вошёл. */
  | 'expiredGuest'
  | 'missing'
  | 'network'
  | 'rateLimit'
  | 'generic';

export interface ConfirmInput {
  hasToken: boolean;
  /** Идёт запрос подтверждения (первый или «Повторить»). */
  verifying: boolean;
  verified: boolean;
  error: VerifyErrorCode | null;
  signedIn: boolean;
  /** Подтверждена ли почта вошедшего; undefined — ещё узнаём (профиль грузится). */
  emailVerified: boolean | undefined;
  /** Повторная отправка ответила `already_verified`. */
  alreadyVerified?: boolean;
}

/** Какой экран показать. Различить «использована» и «истекла» нельзя — различаем по тому, кто открыл. */
export function confirmScreen(input: ConfirmInput): ConfirmScreen {
  if (!input.hasToken) return 'missing';
  if (input.alreadyVerified) return 'already';
  if (input.verifying) return 'pending';
  if (input.verified) return 'success';
  switch (input.error) {
    case 'EXPIRED_TOKEN':
      if (!input.signedIn) return 'expiredGuest';
      if (input.emailVerified === undefined) return 'pending';
      return input.emailVerified ? 'already' : 'expiredApp';
    case 'NETWORK':
      return 'network';
    case 'RATE_LIMIT':
      return 'rateLimit';
    case 'UNKNOWN':
      return 'generic';
    default:
      return 'pending';
  }
}
